<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Production</el-breadcrumb-item>
    <el-breadcrumb-item>Factory Schedule</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
     <el-row>
        <el-col :span = "6">
      <el-form-item label="Supplier:" label-width="115px" >
        <el-input v-if="this.brandParam.userType==='2'" v-model="formInline.supplier" disabled></el-input>
        <el-input v-if="this.brandParam.userType!=='2'" v-model="formInline.supplier" placeholder="Supplier"></el-input>
      </el-form-item>
      </el-col>
      <el-col :span = "6">
      <el-form-item label="Brand:" label-width="130px">
          <el-select v-model="formInline.brands" multiple collapse-tags
            style="margin-left: 0px;"  filterable
            placeholder="please choose">
          <el-option
          v-for="item in this.brandList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
          </el-form-item>
      </el-col>
      <el-col :span = "12">
        <el-form-item label="Sch Date:" label-width="130px">
                <el-date-picker
                  v-model="formInline.schDate"  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Start Date"
                  end-placeholder="End Date">
                </el-date-picker>
              </el-form-item>

      </el-col>

      </el-row>

      <el-row>
        <el-col :span = "6">
<el-form-item label="Category:" label-width="115px">
        <el-select v-model="formInline.category" multiple collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in this.categoryList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
        </el-col>
        <el-col :span = "6">

        <el-form-item label="Incoterm Town:" label-width="130px">
                <el-select v-model="formInline.incotermTown" multiple collapse-tags
                      style="margin-left: 0px;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.incotermTownList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              </el-col>
        <el-col :span = "12">
        <el-form-item style="margin-left: 127px;">
          <el-button type="primary" @click="onSubmit">Search</el-button>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
        </el-form-item>
         </el-col>

      </el-row>
      </el-form>
      <div style="overflow: auto;width: 100%;">
      <table width="2000px" class="table-style" align="center" cellspacing=0 cellpadding=0>
          <tbody>
              <tr class="table-header">
                  <td colspan="4"></td>
                  <td v-for= "(item,index) in allYymmWeekCntList" :colspan="item[1]" v-bind:key="index">{{ item[0] }}</td>
                  <td>Total</td>
              </tr>
              <tr class="table-header">
              <td>Supplier</td>
              <td>Brand</td>
              <td>Item</td>
              <td>Item Name</td>
              <td v-for= "(item,index) in allWeeksNbrList" v-bind:key="index">{{ item }}</td>
              <td></td>
              </tr>
              <template v-for= "exportSch in exportSchList">

                <template v-for= "(exportBrand,index) in exportSch.exportBrands">
                  <tr v-for= "(item,index1) in exportBrand.itemArr" v-bind:key="item.id">
                  <td v-if="index===0 && index1===0" :rowspan="exportSch.itemLength">{{exportSch.supplier}}</td>
                  <td v-if="index1===0" :rowspan="exportBrand.itemArr.length">{{exportBrand.name}}</td>
                  <td>{{item.code}}</td>
                  <td>{{item.name}}</td>
                  <td v-for= "(week,index2) in item.weeks" :key="'2-'+index2">{{ checkZero(numFormat(Math.round(week.value * 10) / 10))}}</td>
                  <td>{{ checkZero(numFormat(Math.round(item.total * 10) / 10))}}</td>
              </tr>
              </template>
              <tr v-bind:key="exportSch.supplier">
              <td class="sub-total">{{ exportSch.supplier }} Total</td>
              <td class="sub-total"></td>
              <td class="sub-total"></td>
              <td class="sub-total"></td>
              <td class="sub-total" v-for= "(supplierTotal,index) in exportSch.oneSupplierTotal" v-bind:key="index">{{ checkZero(numFormat(Math.round(supplierTotal * 10) / 10)) }}</td>
              <td class="sub-total">{{checkZero(numFormat(Math.round(exportSch.oneSupplierSum * 10) / 10))}}</td>
              </tr>
              </template>
              <tr class="total">
                <td class="total">TOTAL</td>
                <td></td>
                <td></td>
                <td></td>
                <td v-for= "(allSupplierWeekTotalItem,index) in allSupplierWeekTotal" v-bind:key="'1-'+index">{{ checkZero(numFormat(Math.round(allSupplierWeekTotalItem * 10) / 10))}}</td>
                <td class="total">{{ checkZero(numFormat(Math.round(valueTotal * 10) / 10)) }}</td>
              </tr>
              </tbody>
              </table>
              </div>

  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        schDate: '',
        category: [],
        brands: [],
        incotermTown: [],
        supplier: ''
        // page: 1,
        // rows: 100
      },
      userName: '',
      exportSchList: [],
      brandList: [],
      allYymmWeekCntList: [],
      allWeeksNbrList: [],
      allSupplierWeekTotal: [],
      valueTotal: '',
      categoryList: '',
      incotermTownList: '',
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    if (this.brandParam.userType === '2') {
      this.formInline.supplier = this.brandParam.userName
    }
    this.getBrands()
    this.categoryIncormtownList()
    this.getExportSchList()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    /* async getOrg () {
      const { data: res } = await this.$http.get('/userManagement/getUser', { params: this.brandParam })
      this.formInline.supplier = await res.user.org
      console.log('res.user === ' + res.user.salesRep)
    }, */
    async getExportSchList () {
      var brandsStr = ''
      this.schDateStart = ''
      this.schDateEnd = ''
      if (this.formInline.schDate) {
        if (this.formInline.schDate.length) {
          this.schDateStart = this.formInline.schDate[0]
          this.schDateEnd = this.formInline.schDate[1]
          this.formInline.schDate = [...this.formInline.schDate].join(',')
        }
      }
      var incotermTownStr = ''
      if (this.formInline.incotermTown && this.formInline.incotermTown.length) {
        this.formInline.incotermTown = [...this.formInline.incotermTown].join(',')
        incotermTownStr = this.formInline.incotermTown
      }
      var categoryStr = ''
      if (this.formInline.category && this.formInline.category.length) {
        this.formInline.category = [...this.formInline.category].join(',')
        categoryStr = this.formInline.category
      }
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/show/exportScheduleList', { params: this.formInline })

      this.allYymmWeekCntList = await res.allYymmWeekCntList
      this.allWeeksNbrList = await res.allWeeksNbrList
      this.allSupplierWeekTotal = await res.allSupplierWeekTotal
      this.valueTotal = await res.total
      this.exportSchList = await res.exportSchList
      this.updateTime = await res.createTime

      if (incotermTownStr !== '') {
        await this.$set(this.formInline, 'incotermTown', incotermTownStr.split(','))
      }
      if (categoryStr !== '') {
        await this.$set(this.formInline, 'category', categoryStr.split(','))
      }
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      await this.$set(this.formInline, 'schDate', [this.schDateStart, this.schDateEnd])
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getExportSchList()
    },
    exportToExcel () {
      window.open('https://www.myirequest.com:8081/show/exportWeeklySchedule?supplier=' + this.formInline.supplier + '&brands=' + this.formInline.brands + '&incotermTown=' + this.formInline.incotermTown +
       '&category=' + this.formInline.category + '&schDate1=' + this.formInline.schDate1 + '&token=' + encodeURIComponent(this.formInline.token) // + '&poDate=' + this.formInline.poDate, '_parent')
      , '_parent')
    },
    async categoryIncormtownList () {
      const { data: res } = await this.$http.get('/show/categoryIncormtownList')
      this.categoryList = await res.categoryList
      this.incotermTownList = await res.incotermTownList
    },
    numFormat (numrc) {
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    checkZero (value) {
      if (value === 0 || value === 0.0 || value === '0') {
        return ''
      }
      return value
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-style {
    // width: 100%;
    border: 0.1px solid #ddd;
    border-collapse: collapse;
    font-size: 12px;
    font-family:Consolas;
    line-height: 35px;
    color: #606266;
    // overflow-x: scroll;
  }
  // tbody {
  //   overflow-x: auto;
  // }
  .table-header {
    // background-color: rgb(192,192,192);
    font-weight: 500;
    line-height: 45px;
    // background-color: rgb(214,237,239);
    border: 1px solid #ddd;
  }
  td {
    border: 0.1px solid #ddd;
    // color: #8E2323;
  }
  .sub-total {
    background-color: rgb(230,230,230);
    // color: rgb(254,82,107);
  }
  .total {
    background-color: rgb(192,192,192);
    line-height: 39px;
  }

</style>
